import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-translation-options',
  template: `
    <div style="margin-bottom: 20px">
      {{ 'CONTENT_IN' | translate }} {{ defaultLanguage.name }}:
      <img
        src="./assets/img/flags/{{ defaultLanguage.lang }}.png"
        alt="{{ defaultLanguage.name }}"
      />
      <span class="btn-toolbar pull-right">
        <span
          class="btn btn-xs"
          *ngFor="let language of additionalLanguages"
          (click)="openedTranslation.emit(language)"
        >
          <img src="./assets/img/flags/{{ language.lang }}.png" alt="{{ language.name }}" />
          {{ language.name }}
        </span>
      </span>
    </div>
  `,
})
export class TranslationOptionsComponent {
  @Input() defaultLanguage: any;
  @Input() additionalLanguages; // : []
  @Output() openedTranslation = new EventEmitter();
}

// , OnInit
// implements OnInit
// defaultLanguageName: string;

// ngOnInit(): void {
// console.log(this.defaultLanguage);
// console.log(this.additionalLanguages);

// this.defaultLanguageName = this.additionalLanguages.find(
//   (x) => x.lang === this.defaultLanguage
// ).name;
// }
